<template>
  <main>
    <Categories />
  </main>
</template>

<script>
import Categories from "../components/Categories.vue";
export default {
  components: { Categories },
  name: "Home",
};
</script>
